<app-status-pill
  [name]="statesNameFlatten[status]"
  [color]="stateColorFlatten[status]"
></app-status-pill>
